import { AsyncValidatorFn, UntypedFormControl } from '@angular/forms';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { concatAll, map, reduce, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { IAuroraState } from '@apps/aurora.state';
import { HasMajorProps } from '@apps/ostk/domain/models/common';

@Injectable({ providedIn: 'root' })
export class UniquenessValidator
{
    constructor (
        private store: Store<IAuroraState>
    )
    {
    }

    validate<T extends HasMajorProps> (getter: (state: IAuroraState) => T[]): AsyncValidatorFn
    {
        return (formControl: UntypedFormControl): Observable<{ notUnique: boolean; } | null> =>
        {
            formControl.markAsTouched();

            const nameToCheck = formControl.value.toUpperCase();

            return this.store
                .select(getter)
                .pipe(
                    take(1),
                    concatAll(),
                    map((item: T) =>
                        item.name.toUpperCase()
                    ),
                    map((name: string) =>
                        name === nameToCheck
                    ),
                    reduce((acc: boolean, curr: boolean) =>
                        acc || curr, false
                    ),
                    map((found: boolean) =>
                        found ? { notUnique: true } : null
                    )
                );
        };
    }
}
